// extracted by mini-css-extract-plugin
export default {"modalHeader":"CustomPAndIFranchiseModal_modalHeader__IMQ2r","tableContainer":"CustomPAndIFranchiseModal_tableContainer__g1JqA"};